      $(document).ready(function() {
      $(".press-links .w100 a:first-child, .press-middle .press-box:first-child").addClass('active'); 
      $('.press-links a').mouseover(function() {  
          var t = $(this).attr('href');
          $(this).addClass('active');
          $('.press-links a').not(this).removeClass('active');           
          $('.press-box').removeClass('active');
          $(t).addClass('active');  
          return false;
      })

if ($(window).width() < 767) {
$(".press-links a").click(function(){

  $('.w100').find('.mopress-box').stop().slideUp();
    $(this).closest('.w100').find('.mopress-box').stop().slideToggle();
});  
}


        
       });